import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { formatOptionalId, resolveDepositExchangeRate } from './depositConstants';

export default function DepositUpdateRateModal({ open, row, onClose, onSaved }) {
  const [rate, setRate] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open && row) {
      const current = resolveDepositExchangeRate(row);
      setRate(current != null ? String(current) : '');
      setError('');
    }
  }, [open, row?.id]);

  if (!open || !row) {
    return null;
  }

  function resetForm() {
    const current = resolveDepositExchangeRate(row);
    setRate(current != null ? String(current) : '');
    setError('');
  }

  async function handleSubmit(event) {
    event.preventDefault();
    const parsed = Number(rate);
    if (!rate || Number.isNaN(parsed) || parsed <= 0) {
      setError('請輸入有效的匯率');
      return;
    }

    setSubmitting(true);
    setError('');
    try {
      await adminApi.depositOfflineUpdateRate({
        id: row.id,
        exchangeRate: parsed,
      });
      onSaved?.();
      onClose();
    } catch (err) {
      setError(err.message || '更新失敗');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>更改匯率 [{formatOptionalId(row.id)}]</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <div className="form-field">
              <span className="form-label">用戶ID</span>
              <p className="form-static">{formatOptionalId(row.memberId)}</p>
            </div>
            <div className="form-field">
              <label htmlFor="depositUpdateRate">
                <span className="required-mark">*</span> 更改匯率
              </label>
              <input
                id="depositUpdateRate"
                type="number"
                min="0"
                step="any"
                value={rate}
                onChange={(e) => setRate(e.target.value)}
              />
            </div>
            <div className="form-field">
              <span className="form-label">入金幣種</span>
              <p className="form-static">{row.currencyName || '—'}</p>
            </div>
            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer admin-modal__footer--center">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={resetForm}
              disabled={submitting}
            >
              重置
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
